module.exports = __webpack_public_path__ + "img/studio_nav_dark.a4470ed6.svg";